import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import CartDrawer from '../components/common/CartDrawer';
import api from '../utils/api';
import toast from 'react-hot-toast';

export default function FeedbackPage() {
  const [form,      setForm]      = useState({ name: '', email: '', mobile: '', message: '', rating: 5 });
  const [submitting, setSubmitting] = useState(false);
  const [sent,       setSent]       = useState(false);

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async e => {
    e.preventDefault();
    if (!form.name || !form.message) { toast.error('Name and message are required.'); return; }
    setSubmitting(true);
    try {
      await api.post('/feedback', form);
      setSent(true);
      toast.success('Feedback sent!');
    } catch { toast.error('Failed to send feedback.'); }
    finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <CartDrawer />
      <main className="flex-1 pt-20">
        {/* Header */}
        <div className="bg-on-surface text-white px-6 md:px-10 py-10">
          <div className="max-w-screen-2xl mx-auto">
            <div className="flex items-center gap-2 font-label text-xs text-gray-500 uppercase tracking-widest mb-3">
              <Link to="/" className="hover:text-gray-300">Home</Link><span>/</span>
              <span className="text-gray-400">Feedback</span>
            </div>
            <h1 className="font-Antic Didone text-5xl md:text-5xl uppercase ">Get in Touch</h1>
            <p className="font-body text-gray-400 mt-4 max-w-xl leading-relaxed">
              Have a question, feedback, or need a quote? Send us a message and we'll get back to you promptly.
            </p>
          </div>
        </div>

        <div className="max-w-screen-2xl mx-auto px-6 md:px-10 py-16">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">

            {/* Contact info */}
            <div className="space-y-6">
              <div>
                <div className="accent-bar" />
                <h2 className="font-lato text-3xl uppercase ">Contact Info</h2>
              </div>
              {[
                { icon: 'mail',        label: 'Email',   value: 'centralfastenerspune@gmail.com' },
                { icon: 'language',    label: 'Website', value: 'centralfasteners.in'       },
                { icon: 'location_on', label: 'Address', value: 'Central Fasteners, Pune, Maharashtra, India'                     },
              ].map(({ icon, label, value }) => (
                <div key={label} className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-primary-container flex items-center justify-center flex-shrink-0">
                    <span className="material-symbols-outlined text-white text-[20px]">{icon}</span>
                  </div>
                  <div>
                    <p className="font-label text-[10px] uppercase tracking-widest text-secondary">{label}</p>
                    <p className="font-body text-sm font-semibold text-on-surface">{value}</p>
                  </div>
                </div>
              ))}

              {/* Google Maps Embed */}
  <div className="w-full overflow-hidden" style={{ height: '200px' }}>
  <iframe
    src="https://maps.google.com/maps?q=18.4925871,73.8564632&z=18&output=embed"
    width="100%"
    height="100%"
    style={{ border: 0 }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    title="Central Fasteners Location"
  />
</div>

              {/* Rating */}
              <div className="pt-4 border-t border-outline-variant/20">
                <p className="font-label text-xs uppercase tracking-widest text-secondary mb-3">Rate your experience</p>
                <div className="flex gap-2">
                  {[1,2,3,4,5].map(n => (
                    <button key={n} onClick={() => setForm(f => ({ ...f, rating: n }))}
                      className={`text-2xl transition-transform hover:scale-110 ${n <= form.rating ? 'text-yellow-400' : 'text-gray-300'}`}>
                      ★
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* Form */}
            <div className="lg:col-span-2">
              {sent ? (
                <div className="flex flex-col items-center justify-center py-16 gap-4 text-center">
                  <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
                    <span className="material-symbols-outlined text-[40px] text-green-600">check_circle</span>
                  </div>
                  <h2 className="font-headline font-black text-3xl uppercase tracking-tight">Message Sent!</h2>
                  <p className="font-body text-secondary">We've received your message and will respond shortly.</p>
                  <button onClick={() => { setSent(false); setForm({ name:'', email:'', mobile:'', message:'', rating: 5 }); }} className="btn-primary mt-2">
                    Send Another
                  </button>
                </div>
              ) : (
                <form onSubmit={submit} className="bg-white border border-outline-variant/20 p-8 space-y-6">
                  <h2 className="font-lato text-3xl uppercase">Send a Message</h2>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div>
                      <label className="input-label">Full Name *</label>
                      <input name="name" value={form.name} onChange={handle} required className="input-field" placeholder="Your name" />
                    </div>
                    <div>
                      <label className="input-label">Mobile Number</label>
                      <input name="mobile" value={form.mobile} onChange={handle} className="input-field" placeholder="+91 XXXXX XXXXX" />
                    </div>
                  </div>

                  <div>
                    <label className="input-label">Email Address</label>
                    <input name="email" type="email" value={form.email} onChange={handle} className="input-field" placeholder="you@example.com" />
                  </div>

                  <div>
                    <label className="input-label">Message *</label>
                    <textarea name="message" value={form.message} onChange={handle} required rows={5}
                      className="input-field resize-none" placeholder="Your enquiry, feedback, or message..." />
                  </div>

                  <button type="submit" disabled={submitting} className="btn-primary w-full justify-center py-4 disabled:opacity-70">
                    {submitting
                      ? <><span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" /> Sending...</>
                      : <><span className="material-symbols-outlined">send</span> Send Message</>
                    }
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
